import store from "../Store";

// Which login does THIS tab hold? Its own memory (the Redux store, filled by the sign-in that happened in this tab) knows.
// localStorage does not: it is shared by every tab of the browser and holds only the LAST login of any of them, so with
// two or three logins in one browser (which the gateway allows: several sessions per trusted device) a tab that read it
// would speak for another tab's login: say hello for it, log it out, end ITS gateway session instead of its own.
// Whatever tells the gateway about a login (heartbeat hello, logout) must use this.
export function tokenOfThisTab() {
  return store.getState().auth?.employeeDetails?.token || null;
}
